import React, { useState } from "react";
import { Modal, Button, Tag, Divider, Form, Radio, RadioChangeEvent } from "antd";
  
const allRoles = ["Minor", "Adult", "Adult Student", "Adult Parent"];

const getCurrentRole = (role: string[] = []) => {
  if (role.includes("Child")) return "Minor";
  if (role.includes("Parent")) return "Adult Parent";
  if (role.includes("Student")) return "Adult Student";
  if (role.includes("Adult")) return "Adult";
  return "";
};

const getOtherRoles = (role: string[] = []) => {
  if (role.includes("Child")) return allRoles.filter((r) => r !== "Minor");
  if (role.includes("Parent")) return ["Adult", "Adult Student"];
  if (role.includes("Student")) return ["Adult", "Adult Parent"];
  if (role.includes("Adult")) return ["Adult Student", "Adult Parent"];
  return [];
};

export const FamilyUserRoles = ({ role, updateUserRoles }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentRole, setCurrentRole] = useState(getCurrentRole(role));
  const [otherRoles, setOtherRoles] = useState(getOtherRoles(role));
  const [newRole, setNewRole] = useState("");

  const save = async () => {
    setLoading(true);
    await updateUserRoles(newRole.split(' '));
    setLoading(false);
  };

  const onOpen = () => {
    setOpen(true);
  };

  const onChange3 = ({ target: { value } }: RadioChangeEvent) => {
    setNewRole(value);
  };

  return (
    <>
      <Button onClick={onOpen} size="small" danger>
        Change Roles
      </Button>
      <Modal
        title="Change User Roles"
        visible={open}
        centered
        onOk={save}
        confirmLoading={loading}
        onCancel={() => setOpen(false)}
        maskClosable={false}
        okButtonProps={{ disabled: !allRoles.includes(newRole) }}
      >
        <div>
          <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
            <Form.Item label="Current Role">
              <Tag color="processing">{currentRole}</Tag>
            </Form.Item>
            <Divider></Divider>
            <Form.Item label="New Role">
              <Radio.Group
                options={otherRoles.map((x) => ({ label: x, value: x }))}
                onChange={onChange3}
                value={newRole}
                optionType="button"
                buttonStyle="solid"
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};
